import { Component, ViewChild, OnInit, Output, EventEmitter, HostListener, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { ContactList } from '../contact-list.model';
import { CustomFields } from './custom-field.model';
import { ContactListAssignMessageDialogComponent } from '../contact-list-assign-message-dialog/contact-list-assign-message-dialog.component';
import { MessageType } from '../contact-list-assign-message-dialog/message-type.enum';
import { map } from 'rxjs/operators';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'contact-list-assign',
  templateUrl: './contact-list-assign.component.html',
  styleUrls: ['./contact-list-assign.component.css']
})

export class ContactListAssignComponent implements OnInit, OnDestroy {

  private modal: any;
  private idContactList: number;
  private contactList: ContactList[] = [];
  private selectedContacts: ContactModel[] = [];
  private selectedContactList: CustomFields[] = [];
  private customFieldJson: CustomFieldJSON[] = [];
  private contactCustomField: ContactCustomField[] = [];
  private assignedContactList: ContactCustomField[] = [];
  private prevSelectedContactList: CustomFields[];
  private prevSelectedIdContactList: number;
  private unsavedChanges: boolean = false;
  private selectedContactListName: string = "";
  private selectedCompany: number;
  private subs = new SubSink();

  @ViewChild('assignForm', { static: false }) assignForm: NgForm;
  @ViewChild('msgDialog', { static: false }) msgDialog: ContactListAssignMessageDialogComponent;

  @Output()
  private assigned: EventEmitter<ContactCustomField[]> = new EventEmitter<ContactCustomField[]>();

  constructor(private repository: HttpRepositoryService, private antiForgery: AntiForgeryTokenService) { }

  ngOnInit() {
    this.modal = $('#assignContactList');

  }

  public show(data: ContactModel[], selectedCompany: number) {
    this.assignForm.reset();
    this.selectedContacts = data;
    this.selectedCompany = selectedCompany;

    this.subs.sink = this.repository.get<ContactList[]>('api/ContactList/GetContactLists?id=' + this.selectedCompany).pipe(map(x => x.data)).subscribe(resp => {
      this.contactList = resp;
    });

    this.modal.modal({
      show: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  close() {
    this.modal.modal('hide');
    $('div.form-group select').val(0); //reset select
    this.selectedContactList = []; // reset displayed custom fields
    this.unsavedChanges = false; //reset unsaved changes;
    this.idContactList = undefined;
    this.selectedContactListName = ""; //reset selectedContactListName
  }

  createContactModel() {
    for (let j = 0; j < this.selectedContacts.length; j++) {
      let id = this.selectedContacts[j].id;
      let email = this.selectedContacts[j].email;
      let phone = this.selectedContacts[j].phone;
      let isActive = this.selectedContacts[j].isActive;

      for (let i = 0; i < this.selectedContactList.length; i++) {
        let idCustomField = this.selectedContactList[i].idCustomField;
        let name = this.selectedContactList[i].name;
        let type = this.selectedContactList[i].type;
        let isRequired = this.selectedContactList[i].isRequired;
        this.customFieldJson[i] = new CustomFieldJSON(idCustomField, null, type, name, isRequired);
      }

      this.selectedContacts[j] = new ContactModel(id, email, phone, isActive, this.customFieldJson);

      this.customFieldJson = [];
    }
  }

  onChange($event) {
    if (this.idContactList != null)
      this.prevSelectedIdContactList = this.idContactList;

    this.idContactList = $event.target.value;
    this.selectedContactListName = this.contactList.find(x => x.id == this.idContactList).name;

    this.checkUnsavedChanges();
    this.prevSelectedContactList = this.selectedContactList;

    this.subs.sink = this.repository.get<any>('api/ContactList/Details/' + this.idContactList + '?companyId=' + this.selectedCompany).subscribe(resp => {
      this.selectedContactList = resp.data.customFields;

      if (this.unsavedChanges) {
        this.selectedContactList = this.prevSelectedContactList;

        this.msgDialog.show("You have unsaved changes do you want to discard them?", MessageType.YESNO, "Unsaved changes confirmation.", () => {
          this.selectedContactList = resp.data.customFields;
          this.prevSelectedContactList = [];
          this.createContactModel();
          this.editContactContactList(this.idContactList);
          this.unsavedChanges = false;
        }, () => { this.idContactList = this.prevSelectedIdContactList; $('div.form-group select').val(this.idContactList) });

      } else {
        this.createContactModel();
        this.editContactContactList(this.idContactList);
      }

    });
  }

  save() {
    if (this.assignForm.valid && this.idContactList != undefined) {
      let contactListName = this.contactList.find(x => x.id == this.idContactList).name;

      for (let i = 0; i < this.selectedContacts.length; i++) {
        let idContact = this.selectedContacts[i].id;
        let customFields: CustomFieldJSON[] = [];

        let contact = this.assignedContactList.find(x => x.idContact == idContact);

        if (contact) {
          let contactCustomFields: CustomFieldJSON[] = JSON.parse(contact.customFieldsJson);
          contactCustomFields = this.objKeysToLowerCase(contactCustomFields);

          for (let j = 0; j < this.selectedContacts[i].customFields.length; j++) {
            let field = contactCustomFields.find(x => x.idCustomField == this.selectedContacts[i].customFields[j].idCustomField);

            if (field) {
              field.value = this.selectedContacts[i].customFields[j].value;
            } else {
              console.log(this.selectedContacts[i].customFields[j]);
              contactCustomFields.push(this.selectedContacts[i].customFields[j]);
            }
            customFields = contactCustomFields;
          }

        } else {
          customFields = this.selectedContacts[i].customFields;
        }

        this.contactCustomField[i] = new ContactCustomField(idContact, this.idContactList, JSON.stringify(customFields));
      }

      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Assign contact', 'error');
        } else {
          this.subs.sink = this.repository.post<ContactCustomField[]>('api/Contact/Assign/', this.contactCustomField, afResp.data).subscribe(resp => {
            if (resp.hasErrors) {
              Toast.Show(resp.error, 'Assign contact', 'error');
            } else {
              Toast.Show('Contact successfully assigned to ' + contactListName, 'Assign contact', 'success');
            }

            this.onSaveCompleted(resp.data);
          });
        }
      })

    } else {
      Object.keys(this.assignForm.controls)
        .forEach(fieldName => {
          this.assignForm.controls[fieldName].markAsDirty();
        });
    }
  }

  private onSaveCompleted(data: ContactCustomField[]) {
    this.close();
    this.assigned.emit(data);
  }

  editContactContactList(id: number) {
    this.subs.sink = this.repository.get<ContactCustomField[]>('api/Contact/ListDetails/' + id).subscribe(resp => {
      this.assignedContactList = resp.data;

      for (let i = 0; i < this.assignedContactList.length; i++) {
        let contact: ContactModel = this.selectedContacts.find(x => x.id == this.assignedContactList[i].idContact);

        if (contact) {
          let contactCustomFields = this.assignedContactList.find(x => x.idContact == contact.id);
          let customFields: CustomFieldJSON[] = JSON.parse(contactCustomFields.customFieldsJson);
          customFields = this.objKeysToLowerCase(customFields);
          let activeCustomFields: CustomFieldJSON[] = [];

          for (let j = 0; j < this.selectedContactList.length; j++) {
            let field: CustomFieldJSON = customFields.find(x => x.idCustomField == this.selectedContactList[j].idCustomField);

            if (field)
              activeCustomFields.push(field);
            else
              activeCustomFields.push(new CustomFieldJSON(this.selectedContactList[j].idCustomField, null,
                this.selectedContactList[j].type, this.selectedContactList[j].name, this.selectedContactList[j].isRequired));
          }
          activeCustomFields.forEach(function (field) {
            if (field.value == 'false')
              field.value = '';
          })

          contact.customFields = activeCustomFields;
        }
      }
    });
  }

  @HostListener("select")
  checkUnsavedChanges() {
    Object.keys(this.assignForm.controls)
      .forEach(fieldName => {
        if (this.assignForm.controls[fieldName].dirty) {
          this.unsavedChanges = true;
        }
      });
  }

  private objKeysToLowerCase(obj: Object[]) {
    let objArr: object[] = [];

    for (let i = 0; i < obj.length; i++) {
      let keys = Object.keys(obj[i]);
      let newObj = {};

      for (let j = 0; j < keys.length; j++) {
        let key = keys[j];
        newObj[key[0].toLowerCase() + key.slice(1)] = obj[i][key];
      }

      objArr.push(newObj);
    }

    return (objArr as CustomFieldJSON[]);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

export class CustomFieldJSON {
  idCustomField: number;
  value: string;
  type: string;
  name: string;
  isRequired: boolean;

  constructor(idCustomField: number, value: string, type: string, name: string, isRequired: boolean) {
    this.idCustomField = idCustomField;
    this.value = value;
    this.type = type;
    this.name = name;
    this.isRequired = isRequired;
  }
}

export class ContactCustomField {
  idContact: number;
  idContactList: number;
  customFieldsJson: string;

  constructor(idContact: number, idContactList: number, customFieldsJson: string) {
    this.idContact = idContact;
    this.idContactList = idContactList;
    this.customFieldsJson = customFieldsJson;
  }
}

export class ContactModel {
  id: number;
  email: string;
  phone: string;
  isActive: boolean;
  customFields: CustomFieldJSON[];

  constructor(id: number, email: string, phone: string, isActive: boolean, customFields: CustomFieldJSON[]) {
    this.id = id;
    this.email = email;
    this.phone = phone;
    this.isActive = isActive;
    this.customFields = customFields;
  }
}

